import React, { useEffect } from 'react';
import arrow from '../Assests/Group 2.png';
import profile from '../Assests/Pic.jpg';
import Aos from 'aos';
import 'aos/dist/aos.css';

const Profile = () => {
  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);

  return (
    <div className='grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-40 mx-4 md:mx-10 mt-10 md:mt-28 container'>
      <div className='order-2 lg:order-1 md:ml-20' data-aos="fade-right">
        <div className='mb-4 md:mb-8'>
          <h1 className='font-inria text-white text-3xl md:text-4xl font-semibold'>SIRI CHANDHANA</h1>
        </div>
        <div>
          <h1 className='font-inria text-white text-4xl md:text-6xl font-bold'>Full-Stack Developer</h1>
        </div>
        <div className='mt-10 md:mt-18'>
          <p className='font-inria text-lg md:text-2xl text-gray-400 text-justify font-thin lg:w-[700px] md:w-[600px] w-[350px]'>
            I'm a full stack developer with a deep enthusiasm for Web3 technologies. Through captivating design and innovative blockchain integration, I aim to craft immersive digital experiences that redefine the possibilities of decentralized applications.
          </p>
        </div>
        <div className='flex gap-4 md:gap-10 mt-6 md:mt-10 mb-4'>
          <a href="#work">
            {/* <h1 className='font-inria text-white font-light text-2xl md:text-4xl'>Hire me</h1> */}
            <button className='font-inria text-white font-light text-xl md:text-2xl rounded-xl border-2 border-[#E4B379] shadow-[#E4B379] shadow-lg w-48 h-16 hover:scale-110'>View My Work</button>
          </a>
          <a  href="#contact" className='flex items-center'>
            {/* <img src={arrow} alt='arrow' className='md:w-auto md:h-auto' /> */}
            <button className='font-inria text-[#242424] font-semibold text-xl md:text-2xl h-16 w-48 rounded-xl border border-[#E4B379] bg-[#E4B379] hover:scale-110'>Get In Touch</button>
          </a>
        </div>
        {/* <div>
          <h1 className='text-white text-lg md:text-2xl' data-aos="fade-left">Contact: <a href="mailto:sirichandhanak06112003@gmail.com" className="text-white hover:underline hover:text-[#E4B379]">sirichandhanak06112003@gmail.com</a></h1>
        </div> */}
      </div>
      <div className='order-1 lg:order-2 mx-auto pr-10 md:mx-40 mt-10 md:mt-10 md:pr-0' data-aos="fade-left">
        <img src={profile} alt='Profile' className='h-72 w-full md:h-96 md:w-full border-2 border-[#E4B379] shadow-[#E4B379] shadow-lg' style={{ borderBottomLeftRadius: '90px' }} />
      </div>
    </div>
  );
}

export default Profile;
